import { render, staticRenderFns } from "./RelevantPacakges.vue?vue&type=template&id=5cf77dd6"
import script from "./RelevantPacakges.vue?vue&type=script&lang=js"
export * from "./RelevantPacakges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports